module.exports = __webpack_public_path__ + "static/img/reliableHome.b96f4e5a.jpeg";